/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 * @description Ratings wrapper
 */

import { Box, Flex } from '@chakra-ui/react'
import { Star } from '@zcode-ui/icons'
import React, { memo } from 'react'

interface RatingsProps {
  fill: string
  size: number
  withAmount?: boolean
}

export const Ratings = memo(({ fill, size, withAmount }: RatingsProps) => {
  return (
    <Flex<'div'> alignItems="center">
      <Box<'div'> marginRight="2px">
        <Star fill={fill} size={size} />
        <Star fill={fill} size={size} />
        <Star fill={fill} size={size} />
        <Star fill={fill} size={size} />
        <Star fill={fill} size={size} />
      </Box>
      {withAmount && (
        <Box<'div'> color="gray.0" fontSize="12px" fontWeight="normal" lineHeight="20px">
          (56k)
        </Box>
      )}
    </Flex>
  )
})
